import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import {
  HardwareDeviceBoundElsewhereError,
  HardwareDeviceNotFoundError,
} from '@/hooks/desktop/utils/hardwareDeviceErrors';
import { unlinkHardwareDevice } from '@/pages/api/scribeAPI';

const UNLINK_HARDWARE_DEVICE = 'unlinkHardwareDevice';

/**
 * Every failure rejects, including 404: the id comes from the backend, so a
 * missing row means the unlink did not happen. The caller owns the error UI.
 */
export function useMutateUnlinkDevice() {
  return useMutation({
    mutationKey: [UNLINK_HARDWARE_DEVICE],
    mutationFn: async (deviceId: string) => {
      try {
        const { data } = await unlinkHardwareDevice(deviceId);
        return data;
      } catch (error) {
        if (isAxiosError(error)) {
          if (error.response?.status === 403) {
            throw new HardwareDeviceBoundElsewhereError();
          }
          if (error.response?.status === 404) {
            throw new HardwareDeviceNotFoundError();
          }
        }
        throw error;
      }
    },
  });
}
